import styled from '@emotion/styled';

export const ShiftCSS = styled.div`
  position: relative;
  margin-left: ${props => `-${(props.index ? 1 : 0) * 16}px`};
  margin-left: ${({ index, shift }) => `calc(-${index ? 1 : 0} * ${shift})`};
`;
